export default function Devolucion() {
  const fecha = new Date().toLocaleDateString("es-AR", {
    day: "numeric",
    month: "long",
    year: "numeric",
  });

  return (
    <div className="max-w-3xl mx-auto px-4 pt-36 pb-10">
      <h1 className="text-2xl md:text-3xl font-bold">Política de Devolución</h1>
      <p className="text-sm text-gray-600 mt-1">Última actualización: {fecha}</p>

      <h2 className="mt-8 font-semibold text-lg">¿Hasta cuándo podés devolver o cambiar?</h2>
      <p className="mt-2">
        Tenés <strong>30 días corridos</strong> desde que recibís tu pedido para solicitar un cambio o devolución.
      </p>

      <h2 className="mt-8 font-semibold text-lg">Condiciones del producto</h2>
      <p className="mt-2">
        Debe estar <strong>sin usar</strong>, con <strong>etiquetas y packaging originales</strong>, y en perfectas condiciones.
      </p>

      <h2 className="mt-8 font-semibold text-lg">Opciones que podés elegir</h2>
      <ul className="list-disc pl-5 mt-2 space-y-1">
        <li><strong>Cambio</strong>: podés cambiarlo por otro artículo del mismo valor.</li>
      </ul>

      <h2 className="mt-8 font-semibold text-lg">Quién paga el envío</h2>
      <p className="mt-2">
        Si fue un error nuestro (defecto, cambio equivocado), nos hacemos cargo del envío.
        Si la devolución es por elección o talle, el costo corre por tu cuenta.
      </p>

      <h2 className="mt-8 font-semibold text-lg">¿Cuánto tarda?</h2>
      <p className="mt-2">
        Una vez recibido el producto en nuestro depósito, procesamos el cambio o reembolso en <strong>5 a 7 días hábiles</strong>.
      </p>

      <h2 className="mt-8 font-semibold text-lg">Cómo comenzar el trámite</h2>
      <p className="mt-2">
        Escribinos a{' '}
        <a href="mailto:wetsoulconsultas@gmail.com" className="underline">
          wetsoulconsultas@gmail.com
        </a>{' '}
        o por WhatsApp a <strong>+54 9 221 544 4828</strong> con tu número de pedido y detalles del producto. Te enviamos los pasos a seguir.   
      </p>
    </div>
  );
}